import {
  ErrorFill24Icon,
  InformationFill24Icon,
  StarsFill24Icon,
  SuccessFill24Icon,
  WarningFill24Icon,
} from "@vygruppen/spor-icon-react";
import { Semantics } from "shared/components/drops/DropsBadge";
import { NoteFill18Icon } from "shared/icons/NoteIcon";

type SemanticsIconProps = {
  semantics: Semantics;
};

const SemanticsIconSVG = ({ semantics }: SemanticsIconProps) => {
  switch (semantics) {
    case "info":
      return <InformationFill24Icon title="Informasjon" color="icon.info" />;
    case "warning":
      return <WarningFill24Icon title="Varsel" color="icon.warning" />;
    case "success":
      return <SuccessFill24Icon title="Suksess" color="icon.success" />;
    case "alarm":
      return <ErrorFill24Icon title="Feilmelding" color="icon.critical" />;
    case "secondaryAlarm":
      return (
        <WarningFill24Icon title="Sekundær feilmelding" color="icon.caution" />
      );
    case "neutral":
      return <NoteFill18Icon style={{ margin: "3px" }} />;
    case "system":
      return <StarsFill24Icon title="Forslag" />;
    case "transparent":
      return <InformationFill24Icon title="Informasjon" color="icon.info" />;
    case "transparentInverted":
      return <InformationFill24Icon title="Informasjon" color="icon.info" />;
  }
};

export const SemanticsIcon = ({ semantics }: SemanticsIconProps) => (
  <SemanticsIconSVG semantics={semantics} />
);
